import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate, showStatus } from "../../../../utils/commonfunction";
import * as coachServices from "../../services/common.services";
import { useTranslation } from "react-i18next";

const CoachView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("Coach Management"), url: "/admin/coach-management/list/1" },
    { title: t("admin.faq.link_view"), url: "" },
  ];



  useEffect(() => {
    coachServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("View Coach")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("Wellness Centre Register ID")} </th>
                          <td className="text-capitalize">
                            {Array.isArray(showdefault?.center_register_id) && showdefault.center_register_id.length > 0
                              ? showdefault.center_register_id
                                  .map(id => `#${id}`)
                                  .join(', ')
                              : "N/A"}
                          </td>

                        </tr>

                        <tr>
                          <th>{t("Wellness Centre Name")} </th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.center_name
                              ? showdefault.center_name
                                  ?.map(name => capitalizeFirstLetter(name))
                                  .join(', ')
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Name")} </th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.name
                              ? capitalizeFirstLetter(showdefault.name)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Email")} </th>
                          <td className="">
                            {showdefault && showdefault?.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Phone Number")} </th>
                          <td className="">
                            {showdefault && showdefault?.phone_number
                              ? showdefault.phone_number
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Specialization")} </th>
                          <td className="text-capitalize">
                            {
                              showdefault?.specialisations?.length || showdefault?.other_specialisation
                                ? showdefault?.specialisations?.map(spec => spec.title).join(', ') + 
                                  (showdefault?.other_specialisation ? `, ${showdefault?.other_specialisation}` : '')
                                : "N/A"
                            }
                          </td>
                          {/* <td className="text-capitalize">
                            {
                              showdefault?.specialisations?.length
                                ? showdefault.specialisations?.map(spec => spec.title).join(', ')
                                : "N/A"
                            }
                          </td> */}
                        </tr>
                        <tr>
                          <th>{t("admin.faq.label_status")}</th>
                          <td>
                            {showdefault && showdefault?.status === 0
                              ? toHtml(showStatus(showdefault.status))
                              : toHtml(showStatus(showdefault.status))}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.list_heading.list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.list_heading.list_heading_modified_date")}</th>
                          <td>
                            {showdefault && showdefault?.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("admin.button.btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoachView;
